module.exports = __webpack_public_path__ + "media/metronic/_theme/media/files/html-bfe202ac433e038725296c75ea4d8082.svg";